import { jsx as s } from "react/jsx-runtime";
import { c as _ } from "../../../clsx-OuTLNxxd.js";
const n = "_tag_t34k6_29", i = {
  tag: n,
  "is-primary-success": "_is-primary-success_t34k6_39",
  "is-secondary-success": "_is-secondary-success_t34k6_44",
  "is-primary-info": "_is-primary-info_t34k6_49",
  "is-secondary-info": "_is-secondary-info_t34k6_54",
  "is-tertiary-info": "_is-tertiary-info_t34k6_59",
  "is-primary-error": "_is-primary-error_t34k6_64",
  "is-primary-highlight": "_is-primary-highlight_t34k6_69",
  "is-secondary-highlight": "_is-secondary-highlight_t34k6_74",
  "is-collection": "_is-collection_t34k6_79",
  "is-small": "_is-small_t34k6_84",
  "is-medium": "_is-medium_t34k6_88",
  "dialog-overlay-show": "_dialog-overlay-show_t34k6_1",
  "dialog-content-show": "_dialog-content-show_t34k6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_t34k6_1"
}, l = {
  "primary-success": "is-primary-success",
  "primary-info": "is-primary-info",
  "primary-error": "is-primary-error",
  "primary-highlight": "is-primary-highlight",
  "secondary-success": "is-secondary-success",
  "secondary-info": "is-secondary-info",
  "secondary-highlight": "is-secondary-highlight",
  "tertiary-info": "is-tertiary-info",
  collection: "is-collection"
}, y = {
  small: "is-small",
  medium: "is-medium"
}, m = ({
  text: r,
  size: o = "small",
  color: a = "primary-success",
  className: t = "",
  ...c
}) => {
  const e = _(i.tag, i[l[a]], i[y[o]], t);
  return /* @__PURE__ */ s("div", { className: e, ...c, children: /* @__PURE__ */ s("p", { children: r }) });
};
m.displayName = "Tag";
export {
  m as Tag
};
